/**************************************************
 * Nombre:       Formulario_Espacio_Notificaciones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {Flag, PhoneIphoneOutlined, WavingHandOutlined} from "@mui/icons-material";
import IngresoSelect from "../../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADONOTIFICACIONES, ESTADOSPRODUCTO} from "../../../Constantes";
import IngresoImagenCrop from "../../../Modulo_formularios/Componentes/IngresoImagenCrop";
import IngresoFecha from "../../../Modulo_formularios/Componentes/IngresoFecha";
import IngresoHora from "../../../Modulo_formularios/Componentes/IngresoHora";
import {enviarNotificacionPrueba} from "../../../CodNegocio/Notificaciones/enviarNotificacionPrueba";
import {useState} from "react";

const Formulario_Espacio_Notificaciones = ({...props}) => {
    const [cargando, setCargando] = useState(false);


    const comprobarUno = async () =>{

        setCargando(true);
        let valores = props.props.getValues()
        let mensaje = valores.saludoUno + ' [Nombre Persona] ' + valores.notificacionUno;
        let celular = valores.celularUno;

        let obj = {
            mensaje: mensaje,
            celular: celular,
        }

        await enviarNotificacionPrueba(obj)
        setCargando(false);

    }

    const comprobarDos = async () =>{

        setCargando(true);
        let valores = props.props.getValues()
        let mensaje = valores.saludoDos + ' [Nombre Persona] ' + valores.notificacionDos;
        let celular = valores.celularDos;

        let obj = {
            mensaje: mensaje,
            celular: celular,
        }

        await enviarNotificacionPrueba(obj)
        setCargando(false);

    }

    const comprobarTres = async () =>{

        setCargando(true);
        let valores = props.props.getValues()
        let mensaje = valores.saludoTres + ' [Nombre Persona] ' + valores.notificacionTres;
        let celular = valores.celularTres;

        let obj = {
            mensaje: mensaje,
            celular: celular,
        }

        await enviarNotificacionPrueba(obj)
        setCargando(false);

    }

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Primera Notificacion </Typography>
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'}
                                   dato={'estadoNotificacionUno'} {...props}
                                   requerido={'Campo requerido'} opciones={ESTADONOTIFICACIONES}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoFecha  nombre={'Fecha Notificacion'}
                                  dato={'fechaUno'} {...props}/>
                </Grid>

                <Grid container size={6}>
                    <IngresoHora  nombre={'Hora Notificacion'} intervalo={60}
                                   dato={'horaUno'} {...props}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={WavingHandOutlined} nombre={'Saludo'}
                                  dato={'saludoUno'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={5} nombre={'Notificacion (Saltos de linea \\n)'}
                                  dato={'notificacionUno'} {...props}

                    />
                </Grid>


                <Grid container size={8} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={PhoneIphoneOutlined} nombre={'Celular (Con indicativo de pais)'}
                                  dato={'celularUno'} {...props}
                    />
                </Grid>

                <Grid container size={4} sx={{justifyContent: 'flex-end'}}>
                    <Button loading={cargando} onClick={() => comprobarUno()} variant={'outlined'}>Comprobar</Button>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', borderTop: 1}}>

                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Segunda Notificacion </Typography>
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'}
                                   dato={'estadoNotificacionDos'} {...props}
                                 opciones={ESTADONOTIFICACIONES}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoFecha  nombre={'Fecha Notificacion'}
                                   dato={'fechaDos'} {...props}/>
                </Grid>

                <Grid container size={6}>
                    <IngresoHora  nombre={'Hora Notificacion'} intervalo={60}
                                  dato={'horaDos'} {...props}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={WavingHandOutlined} nombre={'Saludo'}
                                  dato={'saludoDos'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={5} nombre={'Notificacion (Saltos de linea \\n)'}
                                  dato={'notificacionDos'} {...props}

                    />
                </Grid>


                <Grid container size={8} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={PhoneIphoneOutlined} nombre={'Celular (Con indicativo de pais)'}
                                  dato={'celularDos'} {...props}
                    />
                </Grid>

                <Grid container size={4} sx={{justifyContent: 'flex-end'}}>
                    <Button loading={cargando} onClick={() => comprobarDos()} variant={'outlined'}>Comprobar</Button>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', borderTop: 1}}>

                </Grid>


                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Tercera Notificacion </Typography>
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'}
                                   dato={'estadoNotificacionTres'} {...props}
                                   opciones={ESTADONOTIFICACIONES}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoFecha  nombre={'Fecha Notificacion'}
                                   dato={'fechaTres'} {...props}/>
                </Grid>

                <Grid container size={6}>
                    <IngresoHora  nombre={'Hora Notificacion'} intervalo={60}
                                  dato={'horaTres'} {...props}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={WavingHandOutlined} nombre={'Saludo'}
                                  dato={'saludoTres'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={5} nombre={'Notificacion (Saltos de linea \\n)'}
                                  dato={'notificacionTres'} {...props}

                    />
                </Grid>


                <Grid container size={8} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={PhoneIphoneOutlined} nombre={'Celular (Con indicativo de pais)'}
                                  dato={'celularTres'} {...props}
                    />
                </Grid>

                <Grid container size={4} sx={{justifyContent: 'flex-end'}}>
                    <Button loading={cargando} onClick={() => comprobarTres()} variant={'outlined'}>Comprobar</Button>
                </Grid>



            </Grid>

        </form>

    )

}
export default Formulario_Espacio_Notificaciones